module.exports = __webpack_public_path__ + "media/theme/steps--3--open-3125b220.png";